var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function () {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }

    $trigger.fancybox({
        touch: true,
        infobar: false,
        buttons: ["close"],
    });
};

// Tabs
//-----------------------------------------------------------------
mp.tabs = function () {
    var $element = $("[data-toggle-tab]");

    if (!$element.length) {
        return;
    }

    $(document).on("click", "[data-toggle-tab]", function (e) {
        e.preventDefault();

        $target = $(this).data("toggle-tab");
        $("[data-toggle-tab], [data-toggle-content]").removeClass("active");

        $(this).addClass("active");
        $('[data-toggle-content="' + $target + '"]').addClass("active");
    });
};

// Toggle
//-----------------------------------------------------------------
mp.toggle = function () {
    var $element = $("[data-toggle]");

    if (!$element.length) {
        return;
    }

    $(document).on("click", "[data-toggle]", function (e) {
        e.preventDefault();

        // OPEN ALL
        // $target = $(this).data("toggle");

        // $(this).toggleClass("active").parent().toggleClass("active");
        // $('[data-toggle-content="'+$target+'"]').toggleClass("active");

        // OPEN ONE
        $already_active = $(this).hasClass("active");

        if ($already_active == true) {
            return;
        }

        $target = $(this).data("toggle");

        $("[data-toggle], [data-toggle-content]").removeClass("active");
        $("[data-toggle]").parent().removeClass("active");

        if ($already_active == false) {
            $(this).addClass("active").parent().addClass("active");
            $('[data-toggle-content="' + $target + '"]').addClass("active");
        }
    });

    $(document).on("click", "[data-close]", function (e) {
        $("[data-toggle], [data-toggle-content]").removeClass("active");
    });
};

// Toggle
//-----------------------------------------------------------------
mp.toggleHover = function () {
    var $element = $("[data-toggle-hover]");

    if (!$element.length) {
        return;
    }

    $(document).on("mouseenter click", "[data-toggle-hover]", function (e) {
        e.preventDefault();

        // console.log("hover");

        // OPEN ALL
        // $target = $(this).data("toggle");

        // $(this).toggleClass("active").parent().toggleClass("active");
        // $('[data-toggle-content="'+$target+'"]').toggleClass("active");

        if ($(this).parent().hasClass("slick-slide")) {
            return;
        }

        // OPEN ONE
        $already_active = $(this).hasClass("active");

        if ($already_active == true) {
            return;
        }

        $target = $(this).data("toggle-hover");

        $("[data-toggle-hover], [data-toggle-content]").removeClass("active");
        $("[data-toggle-hover]").parent().removeClass("active");

        if ($already_active == false) {
            $(this).addClass("active").parent().addClass("active");
            $('[data-toggle-content="' + $target + '"]').addClass("active");
        }
    });
};

// Video Play/Pause
//-----------------------------------------------------------------
mp.videoPlayPause = function () {
    $(document).on("click", "video", function (e) {
        e.preventDefault();

        if (this.paused) {
            $(this).attr("controls", true);
            this.play();
        }
    });
};

// Custom input File
//-----------------------------------------------------------------
mp.inputFile = function () {
    var $element = $(".form__upload input");
    var $files_list = $element.parent().next(".form__files");

    if (!$element.length) {
        return;
    }

    $element.on("change", function () {
        const file = this.files[0];

        $files_list.empty();

        if (!file) {
            return;
        }

        $files_list.html(`
          <div class="form__files_item">
            <span class="file-name">${file.name}</span>
          </div>
        `);
    });
};

$(document).ready(function () {
    mp.fancyBox();
    mp.tabs();
    mp.toggle();
    mp.toggleHover();
    mp.videoPlayPause();
    mp.inputFile();
});
